<template>
  <v-container>
    <div>
        <v-alert
                id="alertComp"
                v-model="alert"
                dismissible
                type="success"
        >
            {{alertMessage}}
        </v-alert>
    </div>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-layout>
        <v-flex xs12 sm3 md3 d-flex offset-sm1>
            <v-text-field
                    name="nombre"
                    label="Nombre de la agencia"
                    id="nombreAgencia"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                    v-model="nuevaAgencia"
                    required
            ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <div>
            <v-btn @click="newAgengy" large color="primary">Agregar agencia</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-form>
    <br/>
    <ul id="example-1">
      <li v-for="item in this.$store.state.companyAgencies">
        <td width="500px">
          <v-text-field
                  name="nombre"
                  label="Nombre de la agencia"
                  id="nombreAgencia"
                  :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 550) || 'El número de caracteres debe ser menor a 500']"
                  v-model="item.name"
                  required
          ></v-text-field>
        </td>
        <td>
          <v-tooltip top >
            <v-btn fab dark small @click="deleteItemAgency(item)" slot="activator" color="primary">
              <v-icon dark>delete</v-icon>
            </v-btn>
            <span>Eliminar</span>
          </v-tooltip>
        </td>
      </li>
    </ul>
    <br/>
    <br/>        
  </v-container>

</template>
<script>

export default {
  props: ['company'],
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,      
      nuevaAgencia: "",
      alert: false,
      alertMessage: "",
      valid: true
    };
  },
  methods: {
    saveAgencies(){
      //Elimina todas las agencias
      this.$store.dispatch('deleteCompanyAgencyByCompany',this.company.id).then(response => {
      }, error => {
        this.$store.state.progress = false
        this.$store.state.dialogError = true
      })
      //Inserta las agencias
      for(let i=0;i<this.$store.state.companyAgencies.length;i++){
        this.$store.state.companyAgencies[i].id=""
        this.$store.dispatch('addCompanyAgency',this.$store.state.companyAgencies[i]).then(response => {
          this.dialogSuccess = true
        }, error => {
          this.$store.state.progress = false
          this.$store.state.dialogError = true
        })
      }
    },
    newAgengy(){
      //this.$store.state.companyAgencies.push({id:'', name:'', company:this.company})
      this.$store.dispatch('addCompanyAgency', {id:'', name:this.nuevaAgencia, company:this.company}).then(response => {        
        this.alertMessage = "Se guardó la agencia correctamente.";
        this.alert = true;
        this.$vuetify.goTo(0);
        this.loadData();
        this.nuevaAgencia = "";
        this.$refs.form.resetValidation();
      }, error => {
        this.$store.state.progress = false
        this.$store.state.dialogError = true
      })
    },
    deleteItemAgency(item) {          
      confirm('Está seguro de que quiere eliminar el registro?') && 
      this.$store.dispatch('deleteCompanyAgency', item.id).then(response => {
        this.alertMessage = "Se eliminó la agencia correctamente.";
        this.alert = true;
        this.$vuetify.goTo(0);
        this.loadData();
      }, error => {
        this.$store.state.progress = false;
        this.$store.state.dialogError = true;
      });
    },
    loadData() {
      this.$store.dispatch('getCompanyAgenciesByCompany',this.company.id).then(
          response => {
          },
          error => {
              this.$store.state.dialogError = true;
          }
      )
    }
  },
  computed: {},
  created() {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/company/companyAgency/CompanyAgency.vue